import { BillingModel } from "./BillingModel"

export class BillingComissionModel {
    percentage:number = 0
    taxes:number = 0
    grossTotal:number = 0
    total:number = 0
    billing: BillingModel

    constructor(b?: Partial<BillingComissionModel>) {
        Object.assign(this, b)

        this._parseBilling()
    }

    private _parseBilling():void {
        this.billing = new BillingModel(this.billing)
    }
}
